import { removeFileExtensions } from './removeFileExtensions';

export const attachmentAdapter = (attachment) => {
  if (!attachment) return;

  return {
    ...attachment,
    nameWithoutExt: removeFileExtensions(attachment.name) || '',
  };
};
